<div id="convenios-view" class="page-layout blank">
    <div class="content">
        <div class="left">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="20">
                    <app-convenios-list (notifySelectedNode)="onClickEventEmiter($event)"></app-convenios-list>
                </div>
                <div class="widget user-management-view" fxFlex="100" fxFlex.gt-sm="80">
                    <app-convenios-detail *ngIf="isPanelShow" [(selectedNode)]="selectedNode" [(convenioId)]="selectedconvenioId"></app-convenios-detail>
                </div>
            </div>
        </div>
    </div>
</div> 